// Store sent newsletters in memory during development
const sentNewsletters = new Map();

const formatNewsletterContent = (content) => {
  if (!content) return null;
  
  const date = new Date().toISOString().split('T')[0];
  return {
    date,
    content,
    formattedDate: new Date().toLocaleDateString(),
  };
};

export const sendNewsletterEmail = async (to, content) => {
  try {
    const newsletterData = formatNewsletterContent(content);
    
    // In development, store in memory
    sentNewsletters.set(to, [
      ...(sentNewsletters.get(to) || []),
      newsletterData
    ]);

    // Log for development purposes
    console.log(`Newsletter preview for ${to}:`, newsletterData);
    
    return true;
  } catch (error) {
    console.error('Error processing newsletter:', error);
    throw error;
  }
};

// Helper function to get sent newsletters (for development)
export const getSentNewsletters = (email) => {
  return sentNewsletters.get(email) || [];
};